module.exports = __webpack_public_path__ + "static/img/P1070348.ddd4af2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/P1070348.jpg
// module id = mKY4
// module chunks = 0